import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Alert, Link as MuiLink } from '@mui/material';
import FormControl from '@mui/material/FormControl';

import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../services/auth/AuthContext';
import { useTranslation } from 'react-i18next';
import SignInLayout from './SignInLayout';

import Snackbar from '@mui/material/Snackbar';

import OverlayLoader from '../../components/overlayLoader';

import otpService from '../../services/api/otp';
import { getApiErrorMessage } from '../../services/api/utils';


export default function PartnerLogin(props) {
	const { login, setIsAuthenticated } = useAuth();

	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');

	const [showSnackbar, setShowSnackbar] = useState(false);
	const [snackBarMessage, setSnackBarMessage] = useState(false);
	const [snackSeverity, setSnackSeverity] = useState("");
	const [loading, setLoading] = useState(false);

	let navigate = useNavigate();
	const { t } = useTranslation();

	const handleClose = () => {
		setShowSnackbar(false);
		setSnackBarMessage("");
		setSnackSeverity("");
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (username === '' || password === '') {
			setError('Please fill in both fields.');
		} else {
			setLoading(true);
			otpService.partnerLogin(username, password, navigate, setIsAuthenticated)
				.then((response) => {
					if (response) {
						const { access_token, refresh_token } = response;
						login(access_token, refresh_token);
						navigate('/dashboard', { replace: true });
					} else {
						alert('SOMETHING IS UP')
					}
					setLoading(false);
				})
				.catch((error) => {
					// Handle incorrect OTP case
					setError(true);
					setLoading(false);
					const msg = getApiErrorMessage(error);
					setError(msg);
				});
			setError('');
		}
	};

	return (
   <>
  			<Snackbar
  				open={showSnackbar}
  				autoHideDuration={3000}
  				onClose={handleClose}
  			>
  				<Alert
  					onClose={handleClose}
  					severity={snackSeverity}
  					sx={{ width: '100%' }}
  				>
  					<Typography>{t(snackBarMessage)}</Typography>
  				</Alert>
  			</Snackbar>
  			{loading && <OverlayLoader open={loading} text="" />}
  			<SignInLayout>
  								<Typography
  									variant="h5"
  									fontWeight={600}
  									color="primary"
  									mb={0.5}
  								>
  									{t('login')}
  								</Typography>
  								<Box
  									component="form"
  									onSubmit={handleSubmit}
  									sx={{ display: "flex", flexDirection: "column", gap: 2 }}
  								>
  									<FormControl fullWidth>
  										<TextField
  											label={t('username.label') || 'username'}
  											required
  											fullWidth
  											id="username"
  											name="username"
  											variant="outlined"
  											onChange={(e) => setUsername(e.target.value)}
  											error={error}
  										/>
  									</FormControl>
  									<FormControl fullWidth>
  										<TextField
  											label={t('password.label') || 'password'}
  											type="password"
  											variant="outlined"
  											required
  											fullWidth
  											value={password}
  											onChange={(e) => setPassword(e.target.value)}
  										/>
  									</FormControl>
  									<FormControl>
  										{error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
  										<Button
  											type="submit"
  											variant="contained"
  											color="primary"
  											fullWidth
  										>
  											{t('login')}
  										</Button>
  									</FormControl>
  									<MuiLink
  										to={'/sign-in'}
  										sx={(theme) => ({
  											alignSelf: 'center',
  											color: theme.palette.text.secondary,
  											fontSize: '0.875rem',
  											textDecoration: 'none',
  											'&:hover': {
  												color: theme.palette.primary.main,
  												textDecoration: 'underline',
  											},
  										})}
  										component={Link}
  									>
  										{t('sign_in.not_a_partner')}
  									</MuiLink>
  								</Box>
  			</SignInLayout>
	
   </>
 );
};
